export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-350px.d419c5d6.jpg";